import React from 'react';
import './OurPlatform.css';
import { useAdobeDataLayer, PageNames } from '../../hooks/useAdobeDataLayer';
import OurPlatformIntro from '../../components/Redesign/OurPlatformIntro';
import Intro from '../../components/Redesign/Intro';
import VideoPlayer from '../../components/Redesign/VideoPlayer';
import platformVideo from 'url:../../assets-optimized/riott-media-2026.mp4';

import AudienceProfilesIntro from '../../components/Redesign/AudienceProfilesIntro';
import AudienceCarousel from '../../components/Redesign/AudienceCarousel';
import OurPlatformTravelerCarousel from '../../components/Redesign/OurPlatformTravelerCarousel';
import OurPlatformReachSection from '../../components/Redesign/OurPlatformReachSection';
import OurPlatformBonvoySection from '../../components/Redesign/OurPlatformBonvoySection';
import OurPlatformInternationalSection from '../../components/Redesign/OurPlatformInternationalSection';

const OurPlatform = () => {
  const { sendPageView } = useAdobeDataLayer();

  React.useEffect(() => {
    sendPageView(PageNames.OurPlatform);
  }, [sendPageView]);

  return (
    <div className='our-platform-page'>
      <OurPlatformIntro />
      <Intro>
        Reach travelers in their most receptive state. From software to luxury, entertainment to the
        basic essentials, we create contextual experiences for brands that{' '}
        <span className='audience-pill cs-intro-pill'>
          <span className='cs-lightning-wrapper'>
            <svg viewBox='0 0 24 24' className='cs-lightning-bolt'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M13 10V3L4 14h7v7l9-11h-7z'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              />
            </svg>
          </span>
          deliver powerful results.
        </span>
      </Intro>
      <VideoPlayer src={platformVideo} title='Marriott Media platform overview video' />
      <AudienceProfilesIntro />
      <AudienceCarousel />
      <OurPlatformReachSection />
      <OurPlatformTravelerCarousel />
      <OurPlatformBonvoySection />
      <OurPlatformInternationalSection />
    </div>
  );
};

export default OurPlatform;
